/** Номер счётчика Яндекс.Метрики. Отдельным модулем: нужен и в _document для <noscript> */
export const METRIKA_ID = 96287733;
